module.exports = __webpack_public_path__ + "static/17-d726d1768ad893ea3657de5c26d08aba.jpg";